export const trainOnlyLihes: number[] = [
    // Round trip train liheIds (AR = Aller-Retour)
    186881, // Travelski Night Express AR - Val Thorens
    186909, // Travelski Night Express AR - Plagne 1800
    186910, // Travelski Night Express AR - Les Arcs 1800
    186911, // Travelski Night Express AR - Tignes Val Claret
    186916, // Travelski Night Express AR - Plagne Centre
    186919, // Travelski Night Express AR - Les Menuires Croisette
    187017, // Travelski Night Express - Les Menuires Brelin
    187149, // Travelski Night Express - Plagne Bellecôte
    // One direction train liheIds (COUCHETTE)
    197630, // Travelski Night Express Paris BSM trajet simple COUCHETTE
    197631, // Travelski Night Express Paris Aime trajet simple COUCHETTE
    197632, // Travelski Night Express Paris Moûtiers trajet simple COUCHETTE
    197633, // Travelski Night Express BSM Paris trajet simple COUCHETTE
    197634, // Travelski Night Express Aime Paris trajet simple COUCHETTE
    197635, // Travelski Night Express Moûtiers Paris trajet simple COUCHETTE
    // One-way compartiment liheIds (COMPARTIMENT)
    197828, // Travelski Night Express Paris BSM trajet simple COMPARTIMENT
    197829, // Travelski Night Express Paris Aime trajet simple COMPARTIMENT
    197830, // Travelski Night Express Paris Moûtiers trajet simple COMPARTIMENT
    197831, // Travelski Night Express BSM Paris trajet simple COMPARTIMENT
    197832, // Travelski Night Express Aime Paris trajet simple COMPARTIMENT
    197833, // Travelski Night Express Moûtiers Paris trajet simple COMPARTIMENT
]